import React from "react";
import { useTranslation } from "react-i18next";
import "./NoJobs.css";
import sadIcon from "../../../../assets/icons/sad.svg";
import fb from "../../../../assets/icons/social1.svg";
import ig from "../../../../assets/icons/social2.svg";
import li from "../../../../assets/icons/social3.svg";
import xIcon from "../../../../assets/icons/social4.svg";

const NoJobs = () => {
  const { t } = useTranslation();

  return (
    <section className="noJobs" aria-label={t("sections.careers.noJobs")}>
      <div className="noJobs-empty">
        <div className="sadholder">
          <img src={sadIcon} alt="" className="noJobs-sadIcon" aria-hidden />
        </div>
        <p className="noJobs-title">{t("sections.careers.noJobs")}</p>
        <p className="noJobs-subtitle">{t("sections.careers.followSubtitle")}</p>

        <div className="noJobs-subscribe">
          <input
            type="email"
            placeholder={t("sections.careers.emailPlaceholder")}
            aria-label={t("sections.careers.emailPlaceholder")}
          />
          <button type="button">{t("sections.careers.subscribe")}</button>
        </div>
      </div>

      <div className="noJobs-social">
        <p>{t("sections.careers.followSocial")}</p>
        <div className="noJobs-socialList">
          <a href="https://www.facebook.com/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <img src={fb} alt="" aria-hidden />
          </a>
          <a href="https://www.instagram.com/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <img src={ig} alt="" aria-hidden />
          </a>
          <a href="https://www.linkedin.com/company/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img src={li} alt="" aria-hidden />
          </a>
          <a href="https://x.com/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="X">
            <img src={xIcon} alt="" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
};

export default NoJobs;
